<template>
    <div class="memberBox">
        <div class="head">
            <div class='htitle'>会员中心</div>
            <div class="bander">
                <div class="ht">
                    <div class="imgb">
                        <img :src="userData.wxHeadImgUrl" alt="图片">
                    </div>
                    <div class="hr">
                        <div class="phon">{{phone}}</div>
                        <div class="vipBox">
                            <i class='iconfont iconkuozhanVIP'></i>
                            <span>{{userData.vipclsname}}</span>
                        </div>
                    </div>
                    <div class="iconBox" @click="showFn">
                        <i class='iconfont iconerweima1'></i>
                    </div>
                </div>
                <div class="hb">
                    <div class="hbc" @click="gotoPage(1)">
                        <i class='iconfont icongerenziliao mt'></i>
                        <span class='textSize'>会员资料</span>
                    </div>
                    <div class="hbc" @click="gotoPage(2)">
                        <i class='iconfont iconqunfengqiabao mt'></i>
                        <span class='textSize'>我的卡券</span>
                    </div>
                    <!--<div class="hbc">-->
                        <!--<i class='iconfont iconjilu mt'></i>-->
                        <!--<span class='textSize'>消费记录</span>-->
                    <!--</div>-->
                    <div class="hbc" @click="gotoPage(3)">
                        <i class='iconfont iconqiandao mt colorIcon'></i>
                        <span class='textSize'>我要签到</span>
                    </div>
                </div>
            </div>
            <div class='hBody'>
                <div class='contq'>
                    <div class='contqH'>我的钱包</div>
                    <div class='contqBody'>
                        <!--<div class='contd' >-->
                            <!--<div class='num'>0</div>-->
                            <!--<div class='contText'>账户余额</div>-->
                        <!--</div>-->
                        <div class='contd' >
                            <div class='num'>{{numTicket}}</div>
                            <div class='contText'>优惠券</div>
                        </div>
                        <div class='contd'>
                            <div class='num'>{{userData.cardScore}}</div>
                            <div class='contText'>积分</div>
                        </div>
                    </div>
                </div>
                <div class='menu'>
                    <div class='contqH'>会员服务</div>
                    <div class='menuBr'>
                        <div class='hbc' @click="gotoPage(4)" >
                            <i class='iconfont icongift met colorIcon2'></i>
                            <span class='textSize'>积分换礼</span>
                        </div>
                        <div class='hbc' @click="gotoPage(6)" >
                            <i class='iconfont met colorIcon3'>&#xe681;</i>
                            <span class='textSize'>积分换券</span>
                        </div>
                        <div class='hbc' @click="gotoPage(5)" >
                            <i class='iconfont iconhuodong met colorIcon4'></i>
                            <span class='textSize'>会员活动</span>
                        </div>
                        <!--<div class='hbc'  >-->
                            <!--<i class='iconfont iconunie737 met colorIcon5'></i>-->
                            <!--<span class='textSize'>会员手册</span>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="zheZhao" v-if="state" @click="showFn">
            <div class="mainban zheZhaoE" @click.stop="">
                <div  class="qrcode"></div >
                <div class='zText'>使用时请将此页面出示给工作人员</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            state:false, //二维码显示
            userData:'',
            phone:'',
            numTicket:0, //卡券数量
        }
    },
    methods:{
        showFn(){ //显示遮罩
            this.state = !this.state
            if(this.state){
                this.$nextTick(()=>{
                    var width = 200;
                    var margin = 2;
                    var qr = window.qrcode(4, 'H');
                    qr.addData(this.userData.cardNo);
                    qr.make(); //3
                    var moduleCount = qr.getModuleCount()
                    var cell = (width - margin * 2) / moduleCount;
                    document.querySelector('.qrcode').innerHTML = qr.createImgTag(cell, margin);

                })
            }
        },
        gotoPage(idx){
            switch (idx) {
                case 1:
                    //会员资料
                    this.$router.push('/appMain/memberDatum')
                    break
                case 2:
                    //我的卡券
                    this.$router.push('/myCoupon')
                    break
                case 3:
                    // //我的签到
                    this.$router.push('/appMain/signIn')
                    break
                case 4:
                    //积分换礼
                    this.$router.push('/appMain/integralGift')
                    break
                case 5:
                    //会员活动
                    this.$router.push('/gameList')
                    break
                case 6:
                    //积分换券
                    this.$router.push('/appMain/integralTicket')
                    break
                case 7:
                    //
                    break
                case 8:
                    //
                    break
            }
        }
    },
    mounted() {
        document.title = "会员中心"
        this.userData = JSON.parse(localStorage.getItem("userData"))
         let p = this.userData.phone
        for(let i=0; i<p.length;i++){  //隐藏手机号
            if(i>3&&i<8){
                this.phone += '*'
            }else {
                this.phone +=p[i]
            }
        }
        let dt = new URLSearchParams()
        dt.append('cardNo', this.userData.cardAccount)
        this.$http.post('/sangto-wrm/vip/coupons/getCoupons', dt).then(({data})=> {

            //brandList 品牌券
            //invalidList 过期
            //marketList 市场券
            //parkList 停车券
            let {brandList, marketList, parkList} = data.data
            this.numTicket = brandList.length + marketList.length + parkList.length
        })
    }
}
</script>
<style lang="scss" scoped>
    .memberBox{
        width: 100%;
        height: 100%;
        background-color: #f0f4f7;
        .head{
            width: 100%;
            height: 150px;
            background-color: #6cf;
            color: #fff;
            position: relative;
            display: flex;
            justify-content: center;
        }
        .htitle {
            font-size: 18px;
            position: absolute;
            top: 40px;
            left: 20px;
        }
        .bander {
            width: 96%;
            height: 160px;
            background-color: #fff;
            position: absolute;
            top: 54%;
            box-shadow: 1px 1px 5px #f5f5f5;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .ht {
            width: 94%;
            height: 50%;
            display: flex;
            position: relative;
        }
        .imgb {
            margin-top: 10px;
            width: 65px;
            height: 65px;
            border-radius: 50%;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .hr {
            flex: 1;
            width: 100%;
            height: 30px;
            margin-left: 12px;
        }
        .phon {
            margin-top: 13px;
            font-size: 18px;
            color: #333;
        }
        .vipBox {
            margin-top: 7px;
            text-align: center;
            /*width: 52px;*/
            height: 22px;
            font-size: 14px;
            border-radius: 10px;
            background-color: #cfb963;
            display: inline-block;
            /*align-items: center;*/
            /*justify-content: center;*/
           padding: 1px 8px 2px 3px;
            .iconkuozhanVIP {
                font-size: 16px;
                position: relative;
                top: 0px;
            }
            span{
                font-size: 12px;
            }
        }
        .iconBox {
            position: absolute;
            top: 11px;
            right: 5px;
            background-color: rgba(0, 0, 0, 0.5);
            width: 50px;
            height: 50px;
            border-radius: 8px;
            display: flex;
        }
        .iconerweima1 {
            margin: auto;
            color: #f5f5f5;
            font-size: 32px;
        }
        .hb {
            width: 94%;
            height: 50%;
            display: flex;
        }
        .hbc {
            flex: 1;
            color: #333;
            display: flex;
            flex-direction: column;
            align-items: center;
            .iconfont{
                font-size: 22px;
            }
        }
        .mt {
            margin-top: 13px;
            color: #2db7f5;
        }
        .textSize {
            margin-top: 5px;
            font-size: 14px;
        }
        .colorIcon{
            color: #fe733a;
        }
        .colorIcon2{
            color: #f4283d;
        }
        .colorIcon3{
            color: #ff4091;
        }
        .colorIcon4{
            color: #ff7654;
        }
        .colorIcon5{
            color: #1ad085;
        }
        .hBody {
            width: 100%;
            height: 300px;
        }
        .contq {
            width: 96%;
            height: 135px;
            background-color: #fff;
            margin: 252px auto 0 auto;
            border-radius: 10px;
            box-shadow: 1px 1px 5px #f5f5f5;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .menu {
            width: 96%;
            height: 144px;
            background-color: #fff;
            margin: 9px auto 0 auto;
            border-radius: 10px;
            box-shadow: 1px 1px 5px #f5f5f5;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .contqH {
            font-size: 16px;
            color: #333;
            width: 94%;
            line-height: 50px;
            text-indent: 5px;
            height: 50px;
            border-bottom: 1px solid #f2f2f2;
        }
        .contqBody {
            display: flex;
            height: 100%;
            width: 94%;
        }
        .contd {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .num {
            margin-top: 17px;
            font-size: 18px;
            color: #333;
        }

        .contText {
            font-size: 16px;
            color: #8f8f8f;
            margin-top: 5px;
        }
        .hbc {
            flex: 1;
            color: #333;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .hbc .iconfont {
            font-size: 24px;
        }
        .menuBr .iconfont {
            font-size: 24px;
        }

        .menuBr {
            display: flex;
            height: 100%;
            width: 94%;
        }
        .met{
            margin-top: 30px;
        }
        .zheZhao {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            z-index: 1000;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
        }
        .zheZhaoE {
            display: flex;
            margin:auto;
        }
        .mainban {
            position: relative;
            width: 250px;
            height: 263px;
            background-color: #fff;
        }
        .zText{
            position: absolute;
            bottom: 10px;
            color: #333;
            font-size: 12px;
            width: 100%;
            text-align: center;
        }
        .qrcode{
            margin: 20px auto 0 auto;
        }
    }
</style>
